<template>
  <div class="select-field-wrapper">
    <div
      class="searchable-select-field"
      :class="{ disabled: disabled, opened: isOpened }"
      v-click-outside="closeContent"
    >
      <div class="icon select-icon" @click="toggleContent"></div>
      <div class="selected-item" @click="toggleContent">
        <span class="placeholder" v-if="value === null">
          {{ placeholder }}
        </span>
        <span class="selected-item-name" v-else>
          {{ value.name }}
        </span>
      </div>
      <div class="select-content" v-show="isOpened">
        <div class="search-field">
          <input
            type="text"
            class="search-input"
            v-model="search"
            ref="search"
            @keydown.down.prevent="pointerForward()"
            @keydown.up.prevent="pointerBackward()"
            @keypress.enter.prevent.stop.self="addPointerElement($event)"
            @keyup.esc="closeContent()"
          />
          <i class="icon fa fa-search"></i>
        </div>
        <alert-box
          v-show="search.length < 2"
          type="warning"
          id="alert-search-input"
          :closeable="false"
          :show-icon="false"
        >
          Please enter more than 2 characters
        </alert-box>
        <alert-box
          v-show="searching"
          type="warning"
          id="alert-searching"
          :closeable="false"
          :show-icon="false"
        >
          Search...
        </alert-box>
        <ul
          class="select-dropdown"
          v-show="searchResult.length"
          @mouseleave="onLeaveList"
        >
          <li
            class="list-item"
            :class="{
              active:
                searchResult.length &&
                pointerId > -1 &&
                option.id === searchResult[pointerId].id &&
                !isHovered
            }"
            v-for="option in searchResult"
            :key="option.id"
            @click="onSelectItem(option)"
            @mouseover="onHoverList"
          >
            {{ option.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import AlertBox from "../Alerts/AlertBox";
export default {
  components: { AlertBox },
  props: {
    searchResult: {
      type: Array,
      required: true
    },

    value: {
      type: Object,
      default: null
    },

    placeholder: {
      type: String,
      default: "Please enter key to search item"
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      search: "",
      searching: false,
      isOpened: false,
      isHovered: false,
      pointerId: null
    };
  },

  mounted() {
    let idx = this.searchResult.length ? 0 : -1;
    if (this.hasValue && this.searchResult && this.searchResult.length) {
      this.searchResult.forEach((option, index) => {
        if (this.value.id === option.id) {
          idx = index;
        }
      });
    }
    this.pointerId = idx;
  },

  methods: {
    closeContent() {
      this.isOpened = false;
      this.search = "";
      this.isHovered = false;
    },

    openContent() {
      this.isOpened = true;
    },

    toggleContent() {
      if (this.isOpened) {
        this.closeContent();
      } else {
        this.openContent();
      }
    },

    onSelectItem(value) {
      this.$emit("input", value);
      this.toggleContent();
    },

    onHoverList() {
      this.isHovered = true;
    },

    onLeaveList() {
      this.isHovered = false;
    },

    hasValue() {
      return (
        this.value &&
        !!this.searchResult.find(option => option.id === this.value.id)
      );
    },

    pointerForward() {
      this.pointerId = (this.pointerId + 1) % this.searchResult.length;
    },

    pointerBackward() {
      this.pointerId =
        (this.pointerId - 1 + this.searchResult.length) %
        this.searchResult.length;
    },

    addPointerElement() {
      this.onSelectItem(this.searchResult[this.pointerId]);
    }
  },

  watch: {
    isOpened(newState) {
      if (newState === true) {
        this.$nextTick(function() {
          this.$refs.search.focus();
        });
      }
    },

    search(newState) {
      this.searching = true;
      this.$emit("change", newState);
    },

    searchResult(newState) {
      this.searching = false;
      if (!this.value) return;
      let idx = newState.length ? 0 : -1;
      if (this.hasValue) {
        newState.forEach((option, index) => {
          if (this.value.id === option.id) {
            idx = index;
          }
        });
      }
      this.pointerId = idx;
    }
  }
};
</script>

<style>
.select-field-wrapper {
  position: relative;
  width: 100%;
  height: 40px;
}

.searchable-select-field {
  position: absolute;
  display: block;
  box-sizing: border-box;
  width: 100%;
  outline: none;
  border-width: 2px;
  border-style: solid;
  border-color: #e5e5e5;
  background: #fff;
  font: 15px/19px "Open Sans", Helvetica, Arial, sans-serif;
  color: #404040;
  cursor: pointer;
  transition: border-color 0.3s;
  -moz-appearance: none;
  -webkit-appearance: none;
  z-index: 100;
}

.searchable-select-field:hover {
  border-color: #b2ddb9;
}

.searchable-select-field.opened {
  border-color: #3aa94c;
}

.searchable-select-field.disabled {
  opacity: 0.4;
  pointer-events: none;
}

.searchable-select-field .icon {
  position: absolute;
  width: 40px;
  height: max-content;
  right: 1px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  text-align: center;
  box-sizing: content-box;
  color: #999;
  font-size: 12px;
}

.searchable-select-field .select-icon {
  height: 34px;
  top: 0;
  transform: translateY(0);
}

.searchable-select-field .select-icon:before {
  position: relative;
  right: 0;
  top: 60%;
  color: #999;
  margin-top: 4px;
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 0;
  content: "";
}

.searchable-select-field .selected-item {
  min-height: 36px;
  display: block;
  box-sizing: border-box;
  padding: 8px 40px 0 8px;
  border-radius: 5px;
  background: #fff;
  font-size: 14px;
}

.searchable-select-field .selected-item .placeholder {
  color: #adadad;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
}

.searchable-select-field .select-content {
  max-height: 300px;
  display: block;
  background: #fff;
  width: 100%;
  overflow: auto;
  z-index: 50;
  padding: 0 3px;
  box-sizing: border-box;
}

.searchable-select-field .select-content .search-field {
  position: relative;
  border: 1px solid #e5e5e5;
  width: 100%;
  height: 30px;
  box-sizing: border-box;
}

.searchable-select-field .select-content .search-field .search-input {
  border: none;
  outline: none;
  height: 100%;
  padding-left: 4px;
  padding-right: 40px;
  width: 100%;
  box-sizing: border-box;
}

.searchable-select-field .select-content .select-dropdown {
  padding: 3px 0;
}

.searchable-select-field .select-content .select-dropdown .list-item {
  font-size: 12px;
  padding: 2px 6px;
}

.searchable-select-field .select-content .select-dropdown .list-item:hover,
.searchable-select-field .select-content .select-dropdown .list-item.active {
  background-color: #3aa94c;
  color: white;
}

.searchable-select-field .select-content .alert.alert-warning,
.searchable-select-field .select-content .alert.alert-warning {
  border: none;
  font-size: 12px;
  margin: 3px 0;
}
</style>
